// extracted by mini-css-extract-plugin
export default {"container":"ContainerFunctioningLandingPage_container__q17fl","info":"ContainerFunctioningLandingPage_info__Zt7mH"};